import { render, staticRenderFns } from "./ScheduleTemplates.vue?vue&type=template&id=53808eb3"
import script from "./ScheduleTemplates.vue?vue&type=script&lang=js"
export * from "./ScheduleTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports